// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* type 1  */
.tableS-board-wrapper--Type1 {
  display: flex;
  flex-direction: column;
  gap: 1vw;
  -webkit-user-select: none;
          user-select: none;
}

/* Код */
.tableS-board-game-code--Type1 {
  width: -moz-fit-content;
  width: fit-content;
  place-self: center;
  display: grid;
  --cell-size: 5vw;
  height: var(--cell-size);
  border: 0.1vw #1a6a7c solid;
  background-color: white;
  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
}

/* ячейки кода */
.tableS-board-game-code-cell--Type1 {
  width: 4vw;
  height: 4vw;
  place-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3vw;
  -webkit-user-select: none;
          user-select: none;
}

/* таблица */
.tableS-table--Type1 {
  --header-size: 4vw;
  --cell-size: 5vw;

  display: grid;
  grid-template-columns:
    var(--header-size)
    repeat(var(--column-count), var(--cell-size));
  gap: 0;
  place-self: center;
  width: max-content;
  background: white;
  border: 0.1vw #1a6a7c solid;
  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
}
.tableS-table--compact--Type1 {
  --header-size: 3vw;
  --cell-size: 4vw;
}

/* заголовок */
.tableS-header--Type1 {
  width: var(--header-size);
  height: var(--header-size);

  display: flex;
  justify-content: center;
  align-items: center;
  place-self: center;
  font-size: 2vw;
  font-weight: bold;
}
.tableS-header--small--Type1 {
  font-size: 1.6vw;
}
/* ячейка */
.tableS-cell--Type1 {
  width: var(--cell-size);
  height: var(--cell-size);

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.7vw;
  font-weight: bold;
  border-left: 0.1vw #1a6a7c solid;
  border-top: 0.1vw #1a6a7c solid;
  background: white;
}
.tableS-cell--small--Type1 {
  font-size: 1.3vw;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/TablesSecret/styles/TablesSBoardType1.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB;;mCAEiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,aAAa;EACb;;iDAE+C;EAC/C,MAAM;EACN,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B;;mCAEiC;AACnC;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,0BAA0B;;EAE1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA,WAAW;AACX;EACE,uBAAuB;EACvB,wBAAwB;;EAExB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/* type 1  */\n.tableS-board-wrapper--Type1 {\n  display: flex;\n  flex-direction: column;\n  gap: 1vw;\n  user-select: none;\n}\n\n/* Код */\n.tableS-board-game-code--Type1 {\n  width: fit-content;\n  place-self: center;\n  display: grid;\n  --cell-size: 5vw;\n  height: var(--cell-size);\n  border: 0.1vw #1a6a7c solid;\n  background-color: white;\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n}\n\n/* ячейки кода */\n.tableS-board-game-code-cell--Type1 {\n  width: 4vw;\n  height: 4vw;\n  place-self: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 3vw;\n  user-select: none;\n}\n\n/* таблица */\n.tableS-table--Type1 {\n  --header-size: 4vw;\n  --cell-size: 5vw;\n\n  display: grid;\n  grid-template-columns:\n    var(--header-size)\n    repeat(var(--column-count), var(--cell-size));\n  gap: 0;\n  place-self: center;\n  width: max-content;\n  background: white;\n  border: 0.1vw #1a6a7c solid;\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n}\n.tableS-table--compact--Type1 {\n  --header-size: 3vw;\n  --cell-size: 4vw;\n}\n\n/* заголовок */\n.tableS-header--Type1 {\n  width: var(--header-size);\n  height: var(--header-size);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  place-self: center;\n  font-size: 2vw;\n  font-weight: bold;\n}\n.tableS-header--small--Type1 {\n  font-size: 1.6vw;\n}\n/* ячейка */\n.tableS-cell--Type1 {\n  width: var(--cell-size);\n  height: var(--cell-size);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.7vw;\n  font-weight: bold;\n  border-left: 0.1vw #1a6a7c solid;\n  border-top: 0.1vw #1a6a7c solid;\n  background: white;\n}\n.tableS-cell--small--Type1 {\n  font-size: 1.3vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
